const siteConfig = {
  brandName: "vappyfurhome",
  displayName: "VAPPYFURHOME",
  logo: {
    image: "/brand-logo.svg",
  },
  description:
    "Expressive fashion and accessories selected for confident, colorful wardrobes.",
  website: "https://www.vappyfurhome.homes",
  companyName: "SPRAYJOY LIMITED",
  currency: "USD",
  currencySymbol: "$",
  locale: "en-US",
  freeShippingThreshold: 350,
  standardShipping: 20,
  announcement: "Free returns within 30 days",
  contact: {
    email: "boost@vappyfurhome.homes",
    hours: "Monday–Friday, 9am–6pm HKT",
    address:
      "UNIT 1603, 16/F THE L. PLAZA, 367-375 QUEEN'S RD CENTRAL, SHEUNG WAN, HONG KONG",
  },
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 2,
  }).format(Number(value));

export const readSessionValue = (key, fallback = null) => {
  if (typeof window === "undefined") return fallback;
  try {
    return window.sessionStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
};

export const writeSessionValue = (key, value) => {
  if (typeof window === "undefined") return false;
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const removeSessionValue = (key) => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Session state is optional; the shopping flow remains usable without it.
  }
};

export default siteConfig;
